import { CheckCircle2, HelpCircle } from 'lucide-react';
import PublicSiteLayout from '../components/PublicSiteLayout';

const faqGroups = [
  {
    title: 'Product basics',
    questions: [
      ['What is Little Adda?', 'Little Adda is a family copilot that finds actionable information in school emails and drafts reminders, tasks, and calendar suggestions for parent review.'],
      ['Who is Little Adda for?', 'It is designed for parents and caregivers coordinating school communication, household responsibilities, and family schedules.'],
      ['Is Little Adda a school or school-district service?', 'No. Little Adda is a parent-focused organization product and is not presented as a school or school-district service.'],
    ],
  },
  {
    title: 'Email and suggestions',
    questions: [
      ['What can Little Adda look for in school communication?', 'It is designed to identify likely dates, deadlines, forms, fees, supply requests, attachments, and schedule changes that may require parent action.'],
      ['Does Little Adda add events or tasks automatically?', 'No. Suggested reminders, tasks, and calendar items wait for a parent to approve, edit, or dismiss them.'],
      ['Can a parent change a suggestion?', 'The product is designed around review and approval, including the ability to decide whether a suggested action belongs in the family plan.'],
      ['Can Little Adda replace reading every school message?', 'Little Adda is an organizational aid, not a guarantee that every important detail will be detected. Parents should continue to review original school communication when accuracy matters.'],
    ],
  },
  {
    title: 'Family coordination and privacy',
    questions: [
      ['Can multiple caregivers coordinate?', 'Little Adda is designed to help approved reminders, tasks, lists, and calendar items become part of a shared family flow.'],
      ['Is family workspace information public?', 'No. Family emails, tasks, calendars, lists, and workspace information require authentication and are not intended as public website content.'],
      ['Where can I learn about privacy and security?', 'Read the Privacy and Security page for the product principles and current boundaries described publicly by Little Adda.'],
    ],
  },
];

function FaqPage() {
  return (
    <PublicSiteLayout
      eyebrow="Frequently asked questions"
      title="Clear answers before you connect family information."
      lede="Learn how Little Adda approaches school communication, suggested actions, parent approval, caregiver coordination, and private family workspaces."
    >
      <section className="mx-auto max-w-5xl px-5 py-16 sm:px-8 sm:py-24">
        <div className="grid gap-12">
          {faqGroups.map((group) => (
            <section key={group.title} aria-labelledby={`faq-${group.title.replaceAll(' ', '-').toLowerCase()}`}>
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-teal-50 text-teal-800"><HelpCircle className="h-5 w-5" /></span>
                <h2 id={`faq-${group.title.replaceAll(' ', '-').toLowerCase()}`} className="text-2xl font-black">{group.title}</h2>
              </div>
              <div className="mt-5 grid gap-3">
                {group.questions.map(([question, answer]) => (
                  <details key={question} className="group rounded-[22px] border border-slate-200 bg-white p-5 shadow-subtle open:border-teal-200">
                    <summary className="flex cursor-pointer list-none items-start justify-between gap-4 text-lg font-black">
                      {question}<CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-teal-700" aria-hidden="true" />
                    </summary>
                    <p className="mt-4 max-w-3xl border-t border-slate-100 pt-4 leading-8 text-slate-600">{answer}</p>
                  </details>
                ))}
              </div>
            </section>
          ))}
        </div>
      </section>
    </PublicSiteLayout>
  );
}

export default FaqPage;
